import { useNavigate } from "react-router-dom"

import FeatureGrid from "../../../../components/FeatureGrid"
import FullPageContentContainer from "../../../../components/FullPageContentContainer"
import { useAppSelector } from "../../../../redux"
import DeviceCards from "../../components/DeviceCards"
import Reviews from "../../components/Reviews"
import TitleCards from "../../components/TitleCards"
import TrustedList from "../../components/TrustedList/TrustedList"
import VoicyIntegration from "../../components/VoicyIntegration"
import {
  Box,
  Button,
  Card,
  Container,
  Stack,
  Toolbar,
  Typography,
} from "@podcastsoundboard/ps-lib/ui"
import ChevronRightIcon from "@podcastsoundboard/ps-lib/ui/icons/ChevronRight"

function SectionHeader({
  title,
  subtitle,
}: {
  title: string
  subtitle?: string
}) {
  return (
    <>
      <Typography
        variant="h4"
        component="h2"
        style={{ marginBottom: subtitle ? 2 : 6 }}
        color="text.primary"
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="body1"
          component="p"
          className="mb-12"
          color="text.primary"
        >
          {subtitle}
        </Typography>
      )}
    </>
  )
}
export default function HomeContent() {
  const navigate = useNavigate()
  const currentUserProfile = useAppSelector((state) => state.currentUserProfile)

  // const [welcomeDialogOpen, setWelcomeDialogOpen] = React.useState(true)

  return (
    <>
      <Box className="hero pb-20">
        <Toolbar />

        {/* <ThemeProvider theme={lightTheme}>
          <Snackbar
            open={welcomeDialogOpen}
            onClose={() => setWelcomeDialogOpen(false)}
            action={
              <Stack direction="row" gap="0.5rem" alignItems="center">
                <DeviceChips
                  className="pb-2 pt-2"
                  handleOpenUrl={(url) => window.open(url, "_blank")}
                  navigate={navigate}
                  onlyMobile
                />
                <IconButton
                  size="small"
                  aria-label="close"
                  color="inherit"
                  onClick={() => setWelcomeDialogOpen(false)}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Stack>
            }
            autoHideDuration={6000}
            message="Our mobile apps are now free!"
          />
        </ThemeProvider> */}

        <FullPageContentContainer
          minHeight="auto"
          maxWidth="lg"
          className="pb-0"
        >
          <Box className="home-hero-content">
            <Card
              elevation={2}
              className="w-full rounded-modal px-6 py-12 sm:px-14 sm:py-16"
            >
              <Stack
                direction="column"
                spacing={3}
                justifyContent="center"
                alignItems="center"
              >
                <Typography
                  component="h2"
                  variant="subtitle1"
                  align="center"
                  className="font-semibold uppercase tracking-widest text-primary"
                  fontSize="0.9rem"
                >
                  Bring every moment to life with sound
                </Typography>
                <Typography
                  component="h1"
                  variant="h3"
                  align="center"
                  className="home-title pb-4 font-bold text-text-primary"
                >
                  Your custom soundboard for events and shows
                </Typography>

                <Button
                  size="large"
                  endIcon={<ChevronRightIcon />}
                  onClick={() =>
                    currentUserProfile
                      ? navigate("/app/account/soundboards/new")
                      : navigate("/app/signup")
                  }
                  variant="contained"
                >
                  {currentUserProfile
                    ? "My Soundboards"
                    : "Create a soundboard"}
                </Button>
              </Stack>
            </Card>
          </Box>
        </FullPageContentContainer>

        <FullPageContentContainer
          minHeight="auto"
          maxWidth="lg"
          className="pt-4"
        >
          <TitleCards />
          {/* <Container maxWidth="lg" className="pt-24">
            <UsesChips />
          </Container> */}
        </FullPageContentContainer>
      </Box>

      <Container maxWidth="lg" className="mb-20">
        <SectionHeader
          title="Thousands of happy users"
          subtitle={`
          With nearly a decade of customer collaboration, we've crafted an unbeatable user
          experience with a powerful feature set. Try Podcast Soundboard today, backed by our money-back guarantee.
          `}
        />
        <Reviews />
      </Container>

      <Container maxWidth="lg" className="my-20">
        <SectionHeader
          title="Premium software at an affordable price"
          subtitle={`
            Find Podcast Soundboard for free on the iOS app store and Android
            Play store. We also have premium desktop versions
            at an affordable price for a lifetime license.
            If you want to try the app from your browser, make a free account!
            `}
        />
        <DeviceCards />
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"center"}
          className="px-4 pt-4"
        >
          <Typography
            variant="subtitle2"
            fontSize="1rem"
            style={{
              opacity: 0.8,
              textAlign: "center",
            }}
          ></Typography>
        </Stack>
      </Container>

      <Container maxWidth="lg" className="my-20">
        <SectionHeader
          title="Unbeatable features"
          subtitle={`
            Customize your soundboard entirely to your needs. We're always adding new features.
            If you have any ideas, reach out!
            `}
        />
        <FeatureGrid />
      </Container>

      <Container maxWidth="lg" className="my-20">
        <SectionHeader
          title="Search from a universe of clips"
          subtitle={`
            We integrate with the largest free sound libraries on the web.
            `}
        />
        <VoicyIntegration />
      </Container>

      <Container maxWidth="lg" className="my-20">
        <SectionHeader
          title="Trusted by creators everywhere"
          subtitle={`
          Years of user-driven refinement have shaped Podcast Soundboard into the essential tool it is today.
          `}
        />
        <TrustedList />
      </Container>
    </>
  )
}
